import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';

import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from '@/components/ui/tooltip';
import { useToast } from '@/hooks/use-toast';
import { useUserTourState } from '@/hooks/use-user-tour-state';
import { Locale } from '@/types/locale';
import Button from '@appchoose/button';
import { HelpCircle } from 'lucide-react';

function RelaunchUserTour() {
  const { t, i18n } = useTranslation();
  const { dealId } = useParams<{ dealId: string }>();
  const { dismiss: dismissToast } = useToast();
  const {
    start: startUserTour,
    reset: resetUserTour,
    identify,
  } = useUserTourState();

  const handleHelpButtonClick = () => {
    if (!dealId) return;
    dismissToast();
    resetUserTour();
    const newUserId = `help_session_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
    identify(newUserId, {
      role: 'help_session',
      helpButton: true,
      timestamp: Date.now(),
      locale: i18n.language === 'en' ? Locale.US : Locale.FR,
    });
    setTimeout(() => {
      startUserTour();
    }, 100);
  };

  return (
    <TooltipProvider>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            type="button"
            appearance="outline"
            onClick={handleHelpButtonClick}
            className="flex items-center gap-2 border border-gray-300 font-medium"
          >
            <HelpCircle className="h-4 w-4" />
            {t('ui-v2.components.relaunch-user-tour.button')}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          {t('ui-v2.components.relaunch-user-tour.tooltip')}
        </TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}

export default RelaunchUserTour;
